import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface MinimizeWindowCommand {
  deviceViewEntityId: DeviceViewEntityId;
}

export const minimizeWindow: DeviceViewCommandFactory<MinimizeWindowCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.deviceViewWindows = draft.deviceViewWindows.filter(
        (win) => win.id !== command.deviceViewEntityId,
      );
      draft.activeDeviceViewEntityId = command.deviceViewEntityId;
      draft.deviceViewOpen = true;
    });
  };
